import { render, staticRenderFns } from "./LoadingCard.vue?vue&type=template&id=5b6d1bc6&scoped=true&"
import script from "./LoadingCard.vue?vue&type=script&lang=js&"
export * from "./LoadingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d1bc6",
  null
  
)

export default component.exports